import { useEffect } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useWorkspaceStore } from '../../stores/workspaceStore'

/**
 * WorkspaceInitializer - Component that fetches workspaces once the user is authenticated.
 * This should be placed inside AuthProvider.
 */
export function WorkspaceInitializer({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()
  const { fetchWorkspaces, fetchInvites } = useWorkspaceStore()

  useEffect(() => {
    if (user) {
      fetchWorkspaces()
      fetchInvites()
    }
  }, [user, fetchWorkspaces, fetchInvites])

  return <>{children}</>
}
